import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BatteryWarning, Brain, Activity } from 'lucide-react';
export function ProblemSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-24 bg-[#132118] relative border-y border-white/5" data-id="element-109">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-111">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-112">
            Después de los 40, las reglas del juego{' '}
            <span className="text-emerald-400" data-id="element-113">cambian radicalmente.</span>
          </h2>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto" data-id="element-114">
            El metabolismo que te permitía dormir poco y comer cualquier cosa a
            los 25 ha sido reemplazado por un sistema hipersensible al estrés.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-115">
          <motion.div variants={itemVariants} className="bg-[#162019] p-8 rounded-2xl border border-white/5 hover:border-emerald-500/30 transition-colors" data-id="element-116">
            <BatteryWarning className="w-10 h-10 text-emerald-400 mb-6" data-id="element-117" />
            <p className="text-gray-300 leading-relaxed" data-id="element-118">
              Si te despiertas sintiéndote "borracho" de cansancio aunque hayas
              dormido 8 horas
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-[#162019] p-8 rounded-2xl border border-white/5 hover:border-emerald-500/30 transition-colors" data-id="element-119">
            <Brain className="w-10 h-10 text-emerald-400 mb-6" data-id="element-120" />
            <p className="text-gray-300 leading-relaxed" data-id="element-121">
              Si experimentas una neblina mental que te impide enfocarte después
              del almuerzo
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-[#162019] p-8 rounded-2xl border border-white/5 hover:border-emerald-500/30 transition-colors" data-id="element-122">
            <Activity className="w-10 h-10 text-emerald-400 mb-6" data-id="element-123" />
            <p className="text-gray-300 leading-relaxed" data-id="element-124">
              Si sientes que tu cuerpo ahorra energía agresivamente en forma de
              grasa abdominal
            </p>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6,
        duration: 0.8
      }} className="text-center max-w-3xl mx-auto" data-id="element-125">
          <p className="text-xl text-gray-300 italic" data-id="element-126">
            ...tus mitocondrias están asustadas. Están priorizando la
            supervivencia sobre tu rendimiento, apagando tus interruptores de
            energía uno a uno.
          </p>
        </motion.div>
      </div>
    </section>;
}